export function getParams (url: any, skipHashParams: any) {
    if (!url) {
        throw 'Missing URL Params.';
    }

    var params: any = {};

    /**
     * Hash
     * 1 abc#1      =>  1
     * 2 abc##1     =>  skip
     * 3 abc#       =>  skip
     * 4 abc##      =>  skip
     * 5 #abc       =>  abc
     * 6 ##abc      =>  skip
     * 7 #          =>  skip
     * 8 ###        =>  skip
     */
    var hashPos = url.indexOf('#');
    var uriQuery = url.substr(0, hashPos === -1 ? url.length: hashPos);
    var hashQuery;

    function parse (data) {
        if (!data) {
            return null;
        }
        var params = data.split('&');
        var result = {};
        while (params.length) {
            var item = params.shift();
            /**
             * 1 ABC              =>  ABC = undefined
             * 2 A=B              =>  A   = B
             * 3 A=B== (base64)   =>  A   = B==
             * 4 A=               =>  A   = undefined
             * 5 =B               =>  skip
             * 6 =                =>  skip
             */
            /**
             */
            var separatorPos = item.indexOf('=');
            // 5,6
            if (separatorPos === 0 && item.lastIndexOf('=') === item.indexOf('=')) {
                continue;
            }

            var key;
            var val;
            if (separatorPos !== -1) {
                key = item.substr(0, separatorPos);
                val = item.substr(separatorPos + 1);
            } else {
                if (!item) {
                    continue;
                }
                key = item;
                val = undefined;
            }
            if (result.hasOwnProperty(key)) {
                if ({}.toString.call(result[key]) !== '[object Array]') {
                    result[key] = [result[key]];
                }
                result[key].push(val);
            } else {
                result[key] = val;
            }
        }
        return result;
    }


    if (!skipHashParams) {

        if (hashPos !== -1 && url.lastIndexOf('#') === url.indexOf('#')) {
            hashQuery = url.substr(hashPos + 1);

            params = {
                hash : parse(hashQuery)
            };
        } else {
            // 不处理以下情况: 2,4,6,8
            params = {};
        }
    }

    /**
     * 1 ??abc?ver=1    =>  ver=1
     * 2 ?abc           =>  abc
     * 3 ???abc         =>  abc
     */
    var queryPos = uriQuery.lastIndexOf('?');
    if (queryPos === -1) {
        return params;
    }

    var search = uriQuery.substr(queryPos + 1);
    if (search === -1) {
        return params;
    }

    params.search = parse(search);
    return params;
}



// WEBPACK FOOTER //
// src/kiosk/Context/urlparser.js